/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import { service } from "@ember/service";
import CrudJournalEventBaseComponent from "parog-web/components/forc/abstract/crud-journal-event-based-component";
import journalEventRetrievalStrategies from "parog-web/components/forc/utils/journal-event-retrieval-strategies";
import AnxietyFilledJournalEvent from "parog-web/models/anxiety-filled-journal-event";
import type SemeiaSessionService from "parog-web/services/session";

export default class AnxietyConsultForm extends CrudJournalEventBaseComponent<AnxietyFilledJournalEvent> {
  static forcDisplayName = "Questionnaire d'anxiété";
  static fullComponentId = "anxiety/consult-form";

  static journalEventClass = AnxietyFilledJournalEvent;
  retrieveJournalEvent = journalEventRetrievalStrategies.sourceJournalEvent;

  @service declare session: SemeiaSessionService;

  get keys(): Array<string> {
    return AnxietyFilledJournalEvent.states;
  }

  @action
  computeLabel(value: number): string | undefined {
    switch (value) {
      case 1:
        return "Presque jamais";
      case 2:
        return "Parfois";
      case 3:
        return "Souvent";
      case 4:
        return "Presque toujours";
      default:
        return undefined;
    }
  }

  get shouldShowScore(): boolean {
    return Boolean(this.session.medic) && this.changeset.score != undefined;
  }
}
